import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DashboardApp } from './components/layout';
import WarningStandardDetail from './components/pages/WarningStandardDetail';
import WarningDetail from './components/pages/WarningDetail';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DashboardApp />} />
        <Route path="/warning-standard" element={<WarningStandardDetail />} />
        <Route path="/warning-detail" element={<WarningDetail />} />
      </Routes>
    </Router>
  );
};

export default App;
